<template>
    <div class="feature-flag-provider">
        <slot />
    </div>
</template>

<script setup lang="ts">
import { watch, ref } from 'vue';
import { useLDClient, useLDReady, type LDContext } from 'launchdarkly-vue-client-sdk';
import { FeatureFlagsService } from '@/plugins/launchDarkly/featureFlags.service';

const componentProps = defineProps<{
  ldContext: LDContext;
}>();

const ldClient = useLDClient();
const ldReady = useLDReady();
const featureFlagsService = FeatureFlagsService.getInstance();
const hasInitialized = ref(false);

watch(
  ldReady,
  async (ready) => {
    if (ready && ldClient && !hasInitialized.value) {
      featureFlagsService.setClient(ldClient);
      hasInitialized.value = true;
      
      // Perform initial identify when ready
      try {
        await featureFlagsService.identify(componentProps.ldContext);
      } catch (error) {
        console.warn('Failed to identify user with LaunchDarkly on init', error);
      }
    }
  },
  { immediate: true }
);

watch(
  () => componentProps.ldContext,
  async (newContext, oldContext) => {
    if (ldReady.value && ldClient && hasInitialized.value && oldContext) {
      const contextChanged =
        oldContext.key !== newContext.key || oldContext.anonymous !== newContext.anonymous;

      if (contextChanged) {
        try {
          await featureFlagsService.identify(newContext);
        } catch (error) {
          console.warn('Failed to identify user with LaunchDarkly', error);
        }
      }
    }
  },
  { deep: true }
);
</script>